import React from "react";
import {Col, Container, Row} from "react-bootstrap";

export const AdminStatistics = ({companies, users, leads}) => {
    return (
        <Container >
            <h1>
                Statistik för admin:
            </h1>
            <Row>

                <Col>
                    Totalt antal leads registerade i databasen: {leads.length}
                </Col>
                <Col>
                    Totalt antal konton registerade i databasen: {users.length}
                </Col>
            </Row>
            <Row>
                <Col>
                    Totalt antal företag registerade i databasen: {companies.length}
                </Col>
            </Row>
        </Container>
    )
}
